import React, { useEffect, useState } from 'react'
import { HeaderTable } from '../../HeaderTable'
import Pagination from '../../ui/Pagination'
import axios from 'axios'
import MembershipTable from '../membership/copys/MembershipTable'
import MemberShipFilter from '../membership/MemberShipFilter'
import ModleAddKalah from './ModleAddKalah'

const GET_URL = 'admin/qualification/get_all_members_sub'

const KalahMembership = () => {
    const [modalIsOpen, setModalIsOpen] = useState("");
    const [fetchData, setFetchData] = useState([])

    const [loading, setloading] = useState(true)
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1)
    const [dataFillter, setDataFillter] = useState({
        "memberNumber": "",
    })

    const handleColse = () => {
        setModalIsOpen("")
    }

    const getMemberships = async (page) => {
        setloading(true);
        await axios.get(GET_URL, {
            params: {
                ...dataFillter,
                "page": page,
                "size": perPage,
            }
        })
            .then(response => {
                setFetchData(response?.data?.content)
                setTotalRows(response?.data?.totalPages);
            })
        setloading(false)
    }

    const handlePageChange = (page) => {
        getMemberships(page - 1);
        setCurrentPage(page);
    };

    useEffect(() => {
        getMemberships(currentPage - 1)
    }, [currentPage, perPage, dataFillter])

    return (
        <div className='w-full p-3'>
            <MemberShipFilter
                setDataFillterout={(filter) => {
                    setDataFillter(filter)
                    setCurrentPage(1)
                }}
            />
            <HeaderTable active={"חברי לשכה"}
                setModalIsOpen={setModalIsOpen}
            />
            <MembershipTable members={fetchData} loading={loading} />
            <Pagination currentPage={currentPage} totalPages={totalRows} onPageChange={handlePageChange} />
            {modalIsOpen == "New" && <ModleAddKalah showModal={modalIsOpen == "New"} handleColse={handleColse} getDataTable={getMemberships} />}
        </div>
    )
}

export default KalahMembership
